// src/WhatDoWeOffer.js
import React, { useEffect, useRef } from "react";
import "./WhatDoWeOffer.css";

const FEATURES = [
  {
    icon: "fa-solid fa-video",
    title: "Live learning",
    text: "Learn live with top educators, chat with teachers and other attendees, and get your doubts cleared.",
  },
  {
    icon: "fa-solid fa-book",
    title: "Structured learning",
    text: "Our curriculum is designed by experts to make sure you get the best learning experience.",
  },
  {
    icon: "fa-solid fa-users",
    title: "Community & Networking",
    text: "Interact and network with like‑minded folks from various backgrounds in exclusive chat groups.",
  },
  {
    icon: "fa-solid fa-comments",
    title: "Learn with the best",
    text: "Stuck on something? Discuss it with your peers and the instructors in the inbuilt chat groups.",
  },
  {
    icon: "fa-solid fa-list-check",
    title: "Practice tests",
    text: "With quizzes and live tests, practice what you learned and track your class performance.",
  },
  {
    icon: "fa-solid fa-medal",
    title: "Get certified",
    text: "Flaunt your skills with course certificates. Showcase them on LinkedIn with one click.",
  },
];

const WhatDoWeOffer = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add("fade-up");
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
  }, []);

  return (
    <section ref={sectionRef} id="what-we-offer" className="offer-section animate-section">
      <div className="d-flex flex-column align-items-center">
        <h2 className="offer-heading">What do we offer</h2>
      </div>
      <div className="offer-grid">
        {FEATURES.map((f) => (
          <div key={f.title} className="offer-card">
            <div className="d-flex flex-row">
              <i className={`offer-icon ${f.icon}`}></i>
              <h3>{f.title}</h3>
            </div>
            <p>{f.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhatDoWeOffer;
